<template>
<v-dialog class="mainInfoHolder" 
    v-model="dialog" 
    persistent value="true" 
    :min-height="isMobile ? minHeight : ''" 
    :min-width="isMobile ? '100vw' : '90%'"
    :scrim="!isMobile"
    :fullscreen="isMobile" 
    :class="getModalClasses()"
    >
    <v-card class="mainInfoCard" >
        <v-card-title class="d-flex justify-space-between align-center informationSelectMenu pa-0 pl-6 pr-6" v-if="!isMobile">
            <information-select-menu v-model:activeTab="activeTab" :tabs="tabs" class="informationSelectMenu" />

            <v-btn icon @click="closeModal" :ripple="false" variant="flat" class="crossButton iconButton_light">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mainInfoCardText">
            <v-row>
                <v-col cols="12">
                    <risk-information v-if="menuMode == 'risk' || menuMode == null" />
                    <key-figures v-if="menuMode == 'keyFigures'" />
                    <esg-view v-if="menuMode == 'esg'" />
                    <movement-focus v-if="focusMode == 'movement'" />
                    <industry-performance v-if="menuMode == 'industry'" />
                </v-col>
            </v-row>
            <v-row class="noCountryDataHolder" v-if="noCountryData">
                <v-col>
                    <v-row v-if="isMobile">
                        <v-col cols="10" >

                        </v-col>
                        <v-col cols="1" >
                            <v-btn icon @click="closeModal" :ripple="false" variant="flat" class="crossButton iconButton_light">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="1" >
                        
                    </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <span class="noCountryDataText">
                                No data available
                            </span>
                        </v-col>
                    </v-row>
                    
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
    <information-select-footer class="informationSelectFooter" v-if="!focusMode" />
</v-dialog>
</template>

  
  
<script lang="ts">
import store from '@/store';
import {
    defineComponent
} from 'vue';
import {Service as CountryService} from '../../services/countryService';
import { select } from 'd3';

export default defineComponent({

    props: {
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialog: false,
            activeTab: 0,
            tabs: ['Country Risk', 'Key Figures', 'ESG', 'Industry Performance'],
            isMobile: window.innerWidth <= 900,
            minHeight: '100vh',
            noCountryData: false
        };
    },
    computed: {
        modalMode: {
            get() {
                return store.getters['stateStoreData/modalMode'];
            },
            set(value: any) {
                store.dispatch('stateStoreData/setModalMode', value);
            }
        },
        menuMode: {
            get() {
                return store.getters['stateStoreData/menuMode']
            },
            set(value: any) {
                store.dispatch('stateStoreData/setMenuMode', value)
            }
        },
        focusMode: {
            get() {
                return store.getters['stateStoreData/focusMode']
            },
            set(value: any) {
                store.dispatch('stateStoreData/setFocusMode', value)
            }
        },
        selectedCountry() {
            return store.getters['countryStoreData/selectedCountry'];
        }
    },
    watch: {
        modalMode: {
            immediate: true,
            deep: true,
            handler(val) {
                if (!val) {
                    this.dialog = false;

                } else {
                    if (val == "data") {
                        this.dialog = true;
                    } else {
                        this.dialog = false;

                    }
                }
                this.calculateNoCountryData()
            }
        },
        focusMode: {
            immediate: true,
            deep: true,
            handler(val) {
                if (val == "movement") {
                    this.tabs = ['Movement Focus']
                    this.dialog = true;
                } else {
                    this.tabs = ['Country Risk', 'Key Figures', 'ESG', 'Industry Performance'];
                    this.dialog = false;
                }
                this.calculateNoCountryData()
            }
        },
        isOpen: {
            immediate: true,
            deep: true,
            handler(val) {
                this.dialog = val;
            }
        },
        selectedCountry: {
            immediate: true,
            deep: true,
            handler(val) {
                if (val) {
                    this.buildTabs();
                    this.calculateNoCountryData()
                }
                // this.buildTabs();
            }
        },
        dialog: {
            immediate: true,
            deep: true,
            handler(val) {
                if (!val) {
                    
                    store.dispatch('stateStoreData/setMenuMode', null);
                }
            }
        }
    },
    methods: {
        calculateNoCountryData() {
            if(this.focusMode != 'movement' && this.selectedCountry){
                // this.noCountryData = false;
                this.noCountryData = !CountryService.hasRiskData(this.selectedCountry) && !CountryService.hasKeyFiguresData(this.selectedCountry) && !CountryService.hasESGData(this.selectedCountry) && !CountryService.hasIndustryPerformanceData(this.selectedCountry);
                return;
            }
            
        },
        buildTabs(){
            this.tabs = [];
            if(CountryService.hasRiskData(this.selectedCountry)){
                this.tabs.push('Country Risk');
            }

            if(CountryService.hasKeyFiguresData(this.selectedCountry)){
                this.tabs.push('Key Figures');
            }

            if(CountryService.hasESGData(this.selectedCountry)){
                this.tabs.push('ESG');
            }

            if(CountryService.hasIndustryPerformanceData(this.selectedCountry)){
                this.tabs.push('Industry Performance');
            }

            if(this.tabs.length < 4){
                const tmp = this.tabs[0];
                let newMenuMode = '';

                switch (tmp) {
                    case "Country Risk":
                        newMenuMode = 'risk';
                        break;
                    case "Key Figures":
                        newMenuMode = 'keyFigures';
                        break;
                case "ESG":
                        newMenuMode = 'esg';
                        break;
                    case "Industry Performance":
                        newMenuMode = 'industry';
                        break;
                
                    default:
                        break;
                }

                setTimeout(() => {
                    this.menuMode = newMenuMode;
                }, 100);
                
            }
        },
        getModalClasses() {
            let classes = 'focusMode_' + this.focusMode;

            if (this.isMobile) {
                classes += ' mobileDialog';
            }

            return classes;
        },
        closeModal() {
            this.dialog = false;
            store.dispatch('stateStoreData/setModalMode', null);
            store.dispatch('stateStoreData/setFocusMode', null);
        },
        updateMinHeight() {
            this.minHeight = `${window.innerHeight}px`;
        },
    },
    mounted: function() {
		this.updateMinHeight();
		window.addEventListener('resize', this.updateMinHeight);
    },
    beforeUnmount: function() {
        window.removeEventListener('resize', this.updateMinHeight);
    },

});
</script>
  
  
<style>

.mainInfoHolder  {
  overflow: auto; /* Ensure scrollbar only appears when needed */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.mainInfoHolder ::-webkit-scrollbar-track {
  background: #901a1a;
  border-radius: 10px;
}

.mainInfoHolder ::-webkit-scrollbar-thumb {
  background: #9d0f0f;
  border-radius: 10px;
}

.mainInfoHolder ::-webkit-scrollbar-thumb:hover {
  background: #821d1d;
}

.mainInfoHolder ::-webkit-scrollbar {
  display: none;
}



.mainInfoHolder {
    /* width: 90%;
    height: 90%;
    max-height: 640px; */
}

.mainInfoHolder .v-overlay__content {
    /* height: 90% !important; */
}

.mainInfoCardText {
    /* margin-top: 20px; */
}



.country-card {
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.rank {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: bold;
}

.rank v-icon {
    font-size: 20px;
    margin: 0 5px;
}

.crossButton {
    background: #E7E9EE;
    height: 40px !important;
    width: 40px !important;  
    min-height: 40px !important;
    min-width: 40px !important;
}

.crossButton:hover {
    background: #E7E9EE;
}

.mainInfoCard {
    height: 100%;
    background-color: rgba(255, 255, 255, 0.80);
    border-radius: 8px;
    backdrop-filter: blur(15px);
    max-width: 1440px !important;
    margin: auto;
	
	.contentRow {
		position: relative;
	}
}

.informationSelectMenu {
    background: #F9FAFB;
    height: 60px;
}

/*Desktops */
@media (min-width: 900px) {
    .informationSelectFooter {
        display: none !important;
    }
    .mainInfoCardText{
        min-height: 500px;
    }

    .starDescriptionText p{
        max-width: 550px;
    }
}
.mobileDialog.focusMode_movement .v-overlay__content  {
    min-height: initial !important;
    
    height: 480px !important;
    margin-top: 35%;
    width: 90vw !important;
    min-width: 90vw !important;
    margin-left: 5%;
    margin-right: 5%;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.80);
}

/* mobiles below 900px */
@media (max-width: 900px) {
    .informationSelectMenu {
        /*display: none !important;*/
    }
    .mainInfoHolder {
        margin: 0;
    }
    .mainInfoCard {
        /*height: 50px !important;*/
    }
    /* .mainInfoHolder .v-overlay__scrim{
        display: none;
    }   */
    .mainInfoCardText {
        margin-bottom: 109px;
        /*max-height: 295px;*/
    }

    .focusMode_movement .mainInfoCardText .movement-focus-carousel{
        padding: 25px !important;
        height: 100% !important;
        max-height: 420px !important;
    }
    .mobileDialog.focusMode_movement .v-overlay__content{
        /* height: 520px !important; */
        height: 538px !important;
    	margin-top: 100px; 
    }
}


@media (max-height: 800px) {
    .mobileDialog.focusMode_movement .v-overlay__content{
        /* height: 520px !important; */
        height: 65% !important;
    }
}


/* .mobileDialog .v-overlay__content {
    width: 100% !important;
    min-height: 100vh !important;
} */


.mobileDialog.focusMode_movement .informationSelectMenu{
    display: initial !important;
}

.mobileDialog.focusMode_movement .informationSelectMenu .crossButton{
    margin-top: -3em;
    float: right ;
}

.mobileDialog.focusMode_movement .v-slide-group__container{
    height: 100%;
}


.noCountryDataHolder {
  padding: 70px; /* Adjust padding as needed */
}

.noCountryDataText {
  font-family: 'GCO', sans-serif;
  color: #333;
  font-size: 40px;
  font-weight: 400;
  position: relative;
  text-align: left; /* Ensure text is left-aligned */
  letter-spacing: 0;
}

.noCountryDataText::before {
  content: '';
  position: absolute;
  bottom: 60px;
  left: 0px; /* Adjust as needed to position the red line */
  height: 2px;
  width: 25px;
  background-color: #DC0028;
}

/* Media Queries */
@media (max-width: 900px) {
  .noCountryDataHolder {
    padding: 10px 20px; /* Adjust padding as needed */
  }

  .noCountryDataText {
    font-size: 40px;
  }

  .noCountryDataText::before {
    bottom: 60px;
    width: 0.6em;
    left: 1px;
  }
}

</style>
